<template>
    <page>
        <template slot='content'>
            <div class="col-12 d-flex justify-content-center">
                <!-- <img src="../../public/engrenagem.png" alt="engrenagem_manutencao" width="140"> -->
            </div>
            <div class="col-12 mt-2 d-flex justify-content-center text-center">
                <h1>Página em manutenção</h1>
            </div>
            <div class="col-12 mt-2 d-flex justify-content-center text-center">
                <p>A página de para OS de transpaleteira está em desenvolvimento</p>
            </div>
        </template>
    </page>
</template>
  
<script>
import Page from '@/components/Page'

export default {
    components: {
        Page
    },



}
</script>
  